import { getPreposition } from '@portal-internet/core';
import { useViewport } from 'hooks/3catinfo/useViewport';
import __isEmpty from 'lodash/isEmpty';
import Slider from 'components/3catinfo/Slider';
import Destacat from 'components/3catinfo/Destacat';
import Mosaic from 'components/3catinfo/Mosaic';
import Fila from 'components/3catinfo/Fila';

const getTitol = (props) => {
    const { prefixTitol = '', titol, afegirPreposicioTitol = true } = props;
    if (__isEmpty(prefixTitol) || !afegirPreposicioTitol) return titol;
    return `${prefixTitol}${getPreposition(titol)}${titol}`;
};

const TiraMobile = (props) => {
    const { items, descripcio, routePath } = props;
    let { numColumnsRow } = props;
    const titol = getTitol(props);
    const { isOnlyMobile } = useViewport();
    numColumnsRow = __isEmpty(numColumnsRow) ? 12 : Math.round(numColumnsRow / 5);

    const content = () => {
        return !isOnlyMobile ? (
            <Slider titol={titol} descripcio={descripcio} estil='tiraMobile' format='tiraMobile' fletxes='mig'>
                {items.map((item, i) => (
                    <Destacat
                        format='basic'
                        estil='tiraMobile'
                        key={`mes-llegit-destacat-ranking-vertical-${item.id}-${i}`}
                        item={item}
                        index={i}
                        routePath={routePath}
                        numColumnsRow={numColumnsRow}
                    />
                ))}
            </Slider>
        ) : (
            <Fila tipus='fixed'>
                <Mosaic titol={titol} numColumns={1}>
                    {items.map((item, i) => (
                        <Destacat
                            format='horitzontal'
                            key={`mes-llegit-destacat-ranking-vertical-${item.id}-${i}`}
                            item={item}
                            index={i}
                            routePath={routePath}
                            numColumnsRow={numColumnsRow}
                        />
                    ))}
                </Mosaic>
            </Fila>
        );
    };

    return <>{items && content()}</>;
};

export default TiraMobile;
